import { configureStore } from '@reduxjs/toolkit';
import { spireApi } from './App/reducers/spireApi/spireApi';

const store = configureStore({
    reducer: {
        [spireApi.reducerPath]: spireApi.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(spireApi.middleware)
});

export default store;
